export default __webpack_public_path__ + "static/media/pathways.a53f52e0.gif";